import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import persistReducer from "redux-persist/es/persistReducer";
import persistStore from "redux-persist/es/persistStore";
import userReducer from "./user.store";
import orderReducer from "./order.store";
import addressReducer from "./address.store";
import cartReducer from "./cart.store";
import configReducer from "./config.store";

const persistConfig = {
  key: "root",
  storage
};

const rootReducer = combineReducers({
  user: userReducer,
  order: orderReducer,
  address: addressReducer,
  cart: cartReducer,
  config: configReducer
});

const rehydrationMiddleware = (state) => (next) => (action) => {
  if (action.type === "persist/REHYDRATE" && action?.payload) {
    // Override specific parts of the state here
    const overrideState = {
      ...action.payload,
      order: {
        ...action.payload.order,
        orderPlaced: false
      }
      // Override other parts of the state if needed
    };

    if (action.payload?.order?.orderPlaced)
      overrideState.cart = state.getState().cart;

    return next({ ...action, payload: overrideState });
  }
  return next(action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(rehydrationMiddleware)
});

export const persistor = persistStore(store);

export * from "./address.store";
export * from "./order.store";
export * from "./user.store";
export * from "./cart.store";
export * from "./config.store";
